import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {XmlService} from "../../services/xml.service";
import {take, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {ApiService} from "../../services/api.service";
import {ActivatedRoute} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import { CertificatesService } from '../../services/certificates.service';
import { Certificate } from '../../utils/certificate';

@Component({
  selector: 'app-block',
  templateUrl: './block.component.html',
  styleUrls: ['./block.component.css']
})
export class BlockComponent implements OnInit, OnDestroy {

  form = new FormGroup({
    description: new FormControl('', [Validators.required]),
    type: new FormControl('full', [Validators.required]),
    selectedCert: new FormControl('', [Validators.required])
  });
  private unsubscribe$ = new Subject();
  public certsList: Certificate[];
  public selectedCert = '';
  public completeMessage = '';


  constructor(
    private xmlS: XmlService,
    private apiS: ApiService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private certificateService: CertificatesService
  ) {
  }

  ngOnInit() {
    this.certificateService.getCertsList()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(certsList => this.certsList = certsList);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  submit() {
    for (const control in this.form.controls) {
      if (this.form.controls.hasOwnProperty(control)) {
        this.form.get(control).markAsTouched();
      }
    }

    if (this.form.invalid) {
      return false;
    }

    this.xmlS.prepareXml(this.form.value)
      .pipe(take(1))
      .subscribe((xml: string) => {
        this.certificateService.signHash(this.form.get('selectedCert').value, xml)
          .then((sign) => {
            if (this.form.get('type').value === 'contract') {
              this.http.post('/eisapi/contracts/block', {purchaseNumber: this.route.snapshot.paramMap.get('number')})
                .pipe(take(1))
                .subscribe((res) => {

                });
            }
            this.apiS.post('purchase/block-procedure/' + this.route.snapshot.paramMap.get('number'), this.form.value)
              .pipe(take(1))
              .subscribe((res) => {
                if (res['error'] === undefined) {
                  this.completeMessage = 'Закупка заблокирована';
                } else {
                  this.completeMessage = res['error'];
                }
              });
          });
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/block/block.component.ts